import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://lossaliasfutbolclub.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token a las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  cambiarPassword: (passwordActual, passwordNuevo) =>
    api.put('/auth/cambiar-password', { passwordActual, passwordNuevo }),
};

// Jugadores
export const jugadoresAPI = {
  getAll: (params) => api.get('/jugadores', { params }),
  getById: (id) => api.get(`/jugadores/${id}`),
  create: (data) => api.post('/jugadores', data),
  update: (id, data) => api.put(`/jugadores/${id}`, data),
  delete: (id) => api.delete(`/jugadores/${id}`),
  verificarCedula: (cedula, excludeId) =>
    api.get('/jugadores/verificar-cedula', { params: { cedula, excludeId } }),
  uploadFoto: (id, formData) =>
    api.post(`/jugadores/${id}/foto`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

// Representantes
export const representantesAPI = {
  getAll: (params) => api.get('/representantes', { params }),
  getById: (id) => api.get(`/representantes/${id}`),
  create: (data) => api.post('/representantes', data),
  update: (id, data) => api.put(`/representantes/${id}`, data),
  delete: (id) => api.delete(`/representantes/${id}`),
  verificarCedula: (cedula, excludeId) =>
    api.get('/representantes/verificar-cedula', { params: { cedula, excludeId } }),
};

// Pagos
export const pagosAPI = {
  getAll: (params) => api.get('/pagos', { params }),
  getById: (id) => api.get(`/pagos/${id}`),
  create: (data) => api.post('/pagos', data),
  update: (id, data) => api.put(`/pagos/${id}`, data),
  delete: (id) => api.delete(`/pagos/${id}`),
  confirmar: (id, notas) => api.put(`/pagos/${id}/confirmar`, { notas }),
  rechazar: (id, motivo) => api.put(`/pagos/${id}/rechazar`, { motivo }),
  getTasaBCV: () => api.get('/tasa-bcv'),
  getTasaPorFecha: (fecha) => api.get('/tasa-bcv/fecha', { params: { fecha } }),
  getHistorialTasas: (limit) => api.get('/tasa-bcv/historial', { params: { limit } }),
  getConceptoStatus: (jugador_id, concepto_id) =>
    api.get('/pagos/concepto-status', { params: { jugador_id, concepto_id } }),
};

// Conceptos de Pago
export const conceptosPagoAPI = {
  getAll: (params) => api.get('/conceptos-pago', { params }),
  getById: (id) => api.get(`/conceptos-pago/${id}`),
  create: (data) => api.post('/conceptos-pago', data),
  update: (id, data) => api.put(`/conceptos-pago/${id}`, data),
  toggleActivo: (id) => api.put(`/conceptos-pago/${id}/toggle`),
  delete: (id) => api.delete(`/conceptos-pago/${id}`),
};

// Solicitudes
export const solicitudesAPI = {
  getAll: (params) => api.get('/solicitudes', { params }),
  getById: (id) => api.get(`/solicitudes/${id}`),
  create: (data) => api.post('/solicitudes', data, data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {}),
  aprobar: (id) => api.put(`/solicitudes/${id}/aprobar`),
  rechazar: (id, motivo) => api.put(`/solicitudes/${id}/rechazar`, { motivo }),
  verificarCedula: (cedula) => api.get('/solicitudes/verificar-cedula', { params: { cedula } }),
  verificarDuplicado: (nombres, apellidos, fecha_nacimiento) =>
    api.get('/solicitudes/verificar-duplicado', { params: { nombres, apellidos, fecha_nacimiento } }),
};

// Representante portal
export const representanteAPI = {
  getMisJugadores: () => api.get('/representante/mis-jugadores'),
  getJugadorDetalle: (id) => api.get(`/representante/mis-jugadores/${id}`),
  getMisPagos: (params) => api.get('/representante/mis-pagos', { params }),
  uploadComprobante: (formData) =>
    api.post('/pagos/upload-comprobante', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  uploadDocumento: (jugadorId, formData) =>
    api.post(`/representante/mis-jugadores/${jugadorId}/documento`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  uploadFoto: (jugadorId, formData) =>
    api.post(`/representante/mis-jugadores/${jugadorId}/foto`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

// Dashboard
export const dashboardAPI = {
  getKPIs: () => api.get('/dashboard/kpis'),
  getPagosRecientes: (limit) => api.get('/dashboard/pagos-recientes', { params: { limit } }),
  getIngresosPorConcepto: (mes) => api.get('/dashboard/ingresos-concepto', { params: { mes } }),
  getIngresosPorMetodo: (mes) => api.get('/dashboard/ingresos-metodo', { params: { mes } }),
  getHistoricoIngresos: () => api.get('/dashboard/historico'),
};

export default api;
